import { Pipe, PipeTransform } from '@angular/core';

import { convertKeysToCamelCase } from '../util/string-key-transformation.utils';

@Pipe({
  name: 'transformKeys',
  standalone: true,
})
export class TransformKeysPipe implements PipeTransform {
  /**
   * Transforms keys of an object or array of objects based on the specified transformation type.
   * @param value - The object or array of objects to transform.
   * @param transformationType - The type of transformation to apply (e.g., 'snakeToCamel').
   * @returns The transformed object or array of objects.
   */
  transform(value :any, transformationType :string) :any {
    if (!value) return value;

    switch (transformationType) {
      case 'snakeToCamel':
        return convertKeysToCamelCase(value);
      // Add more transformation types here if needed
      default:
        throw new Error(`Unsupported transformation type: ${transformationType}`);
    }
  }
}
